import { render, staticRenderFns } from "./NewPersonModal.vue?vue&type=template&id=fd282fae&scoped=true&"
import script from "./NewPersonModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./NewPersonModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./NewPersonModal.vue?vue&type=style&index=0&id=fd282fae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd282fae",
  null
  
)

export default component.exports